// extracted by mini-css-extract-plugin
export default {"bubble":"bubble--ZjNne"};